import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';

import { ChurnFlowReasonInfoboxService } from '@core/churn-flow-logic';
import { ChurnFlowSolutionCardI, ChurnReason } from '@core/churn-flow-types';
import {
  ChurnFlowReasonTemplateComponent,
  ChurnFlowSolutionCardComponent,
  ChurnFlowStepTemplateComponent,
} from '@core/churn-flow-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

import { ChurnFlowInsightsComponent } from '../../components/churn-flow-insights/churn-flow-insights.component';
import { ChurnFlowReasonBaseComponent } from '../../components/churn-flow-reason-base.component';

@Component({
  selector: 'tlc-churn-missing-features-page',
  templateUrl: './churn-missing-features-page.component.html',
  styleUrls: ['./churn-missing-features-page.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    ChurnFlowInsightsComponent,
    ChurnFlowReasonTemplateComponent,
    ChurnFlowSolutionCardComponent,
    ChurnFlowStepTemplateComponent,
    IconComponent,
    TranslatePipe,
  ],
})
export class ChurnMissingFeaturesPageComponent extends ChurnFlowReasonBaseComponent {
  protected readonly reason = ChurnReason.MissingFeatures;
  public readonly infoboxMessage: Signal<string | undefined> = inject(
    ChurnFlowReasonInfoboxService,
  ).getReasonInfoboxMessage(ChurnReason.MissingFeatures);

  public readonly exploreWorkarounds: ChurnFlowSolutionCardI = {
    iconVariant: 'dialog',
    title: this.t('tlc.churn_flow.steps.missing_features.solutions.explore_workarounds.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.missing_features.solutions.explore_workarounds.incentive_1'),
      this.t('tlc.churn_flow.steps.missing_features.solutions.explore_workarounds.incentive_2'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.missing_features.solutions.explore_workarounds.cta'),
  };

  public readonly joinTrainingSession: ChurnFlowSolutionCardI = {
    iconVariant: 'training',
    title: this.t('tlc.churn_flow.steps.missing_features.solutions.join_training_session.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.missing_features.solutions.join_training_session.incentive_1'),
      this.t('tlc.churn_flow.steps.missing_features.solutions.join_training_session.incentive_2'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.missing_features.solutions.join_training_session.cta'),
  };

  public readonly makeFeatureSuggestion: ChurnFlowSolutionCardI = {
    iconVariant: 'lightbulb',
    title: this.t('tlc.churn_flow.steps.missing_features.solutions.make_feature_suggestion.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.missing_features.solutions.make_feature_suggestion.incentive_1'),
      this.t('tlc.churn_flow.steps.missing_features.solutions.make_feature_suggestion.incentive_2'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.missing_features.solutions.make_feature_suggestion.cta'),
  };

  public exploreWorkaroundsAction(): void {
    this.openIntercom(
      this.t(
        'tlc.churn_flow.steps.missing_features.solutions.explore_workarounds.intercom_message',
      ),
    );
  }
}
